import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LogOut } from "lucide-react";
import { Logo } from "../components/Logo";
import { useAuthGuard } from "../hooks/useAuthGuard";
import { LeadsTab } from "../components/admin/LeadsTab";
import { PackagerManagement } from "../components/admin/PackagerManagement";
import { RecruitmentList } from "../components/admin/RecruitmentList";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TABS = ["Leads", "Packagers", "Recruitment"];

export default function AdminDashboard() {
  useAuthGuard("admin");
  const nav = useNavigate();
  const [tab, setTab] = useState("Leads");

  const logout = async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#F3F4F6]">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[#E5E7EB]">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-4 flex items-center justify-between">
          <Logo />
          <button
            onClick={logout}
            data-testid="logout-btn"
            className="flex items-center gap-2 text-sm font-semibold text-[#052F24]/70 hover:text-[#052F24] transition-colors"
          >
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-5 sm:px-8 py-10">
        <div className="flex items-center gap-2 mb-8" data-testid="admin-tabs">
          {TABS.map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              data-testid={`admin-tab-${t.toLowerCase()}`}
              className={`rounded-full px-5 py-2.5 text-sm font-bold transition-colors ${
                tab === t ? "bg-[#052F24] text-[#DFFF00]" : "bg-white border border-[#E5E7EB] text-[#052F24]/70 hover:border-[#052F24]/30"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {tab === "Leads" && <LeadsTab />}
        {tab === "Packagers" && <PackagerManagement />}
        {tab === "Recruitment" && <RecruitmentList />}
      </main>
    </div>
  );
}
